import { Flex, Heading, Input, Stack } from '@chakra-ui/react';
import { APIProvider, Map } from '@vis.gl/react-google-maps';
import { memo } from 'react';
import { LuSearch } from 'react-icons/lu';

import { InputGroup } from '@components/ui/input-group';
import LiveStats from '@features/liveView/LiveStats';

const GOOGLE_MAPS_API_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY ?? '';
const MAP_ID = process.env.NEXT_PUBLIC_GOOGLE_MAPS_MAP_ID ?? '';

const LiveViewPage = () => {
  return (
    <Flex w="full" h="full">
      <APIProvider apiKey={GOOGLE_MAPS_API_KEY}>
        <Map
          style={{ width: '100%', height: '100%' }}
          defaultCenter={{ lat: 5.614818, lng: -0.205874 }}
          defaultZoom={12}
          gestureHandling="greedy"
          disableDefaultUI
          mapId={MAP_ID}
        >
          <Flex position="absolute" top="0px" left="0px" p={4} w="full" pointerEvents="none">
            <Stack gap={2} w="full">
              <Heading color="black">My store</Heading>
              <Flex alignSelf="end">
                <InputGroup
                  flex="1"
                  startElement={<LuSearch />}
                  pointerEvents="auto"
                  boxShadow="lg"
                  borderRadius="md"
                >
                  <Input size="sm" placeholder="Search " bg="white" />
                </InputGroup>
              </Flex>
              <Flex pointerEvents="auto" w="fit-content" h="fit-content">
                <LiveStats />
              </Flex>
            </Stack>
          </Flex>
        </Map>
      </APIProvider>
    </Flex>
  );
};

export default memo(LiveViewPage);
